export const xsightVersionInfo = {
    versionPrefix: '25.1.0.'
};

if (!!window.angular) {
  (function(module) {
      'use strict';
      module.value('versionInfo', xsightVersionInfo);

    })(angular.module('about'));
}
